import React from "react";

interface ILoginBoxActionsProps {
  children: React.ReactNode;
}

const LoginBoxActions = (props: ILoginBoxActionsProps) => {
  const { children } = props;

  return <div style={{ flexDirection: "row-reverse", display: "flex" }}>{children}</div>;
};

export default LoginBoxActions;
